import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { errorToast } from "components/toast";
import { successToast } from "components/toast";
import { FormControlLabel, Switch } from "@mui/material";
import Pagination from "components/Pagination";
import { getBlogDataList } from "services/_blog";
import { updateBlogsStatus } from "services/_blog";
import { deleteBlogById } from "services/_blog";
import { getPermissions } from "context/AuthContext";

const Blogs = () => {
  const permissions = getPermissions();
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const createBlog = () => {
    navigate("/admin/blogs/create-blog");
  };

  const initialData = useCallback(async () => {
    let payload = `page=${page}&per_page=${perPage}`;
    const data = await getBlogDataList(payload);
    if (data.data) {
      setRecords(data.data.records || []);
      setBlogData(data.data.records);
      setTotalRecords(data.data.total_records || 0);

      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const handleEdit = async (id) => {
    navigate(`/admin/blogs/edit-blog/${id}`);
  };

  const handleDelete = async (id) => {
    const data = await deleteBlogById(id);
    if (data.data) {
      successToast(data.message);
      initialData();
    } else {
      errorToast(data.message);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      // Call your API to update the status
      const payload = { id, status: newStatus };
      const response = await updateBlogsStatus(payload);

      if (response.data) {
        successToast(response.message);

        setBlogData((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, status: newStatus } : item
          )
        );
      } else {
        errorToast(response.message);
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong!");
    }
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3>Blogs</h3>
                {permissions.includes("create-blog") && (
                  <Button color="info" onClick={createBlog}>
                    Create
                  </Button>
                )}
              </CardHeader>
              <Table
                className="align-items-center table-flush"
                responsive
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className="blog-th-small">
                      #
                    </th>
                    <th scope="col" className="blog-th-title">
                      Title
                    </th>
                    <th scope="col" className="blog-th-short-desc">
                      Short Description
                    </th>
                    <th scope="col" className="blog-th-meta-title">
                      Meta Title
                    </th>
                    <th scope="col" className="blog-th-meta-desc">
                      Meta Description
                    </th>
                    <th scope="col" className="blog-th-status">
                      Status
                    </th>
                    <th scope="col" className="blog-th-created-at">
                      Created At
                    </th>
                    {permissions.includes("update-blog" || "delete-blog") && (
                      <th scope="col" style={{ width: "80px" }} />
                    )}
                  </tr>
                </thead>
                <tbody>
                  {blogData.length > 0 ? (
                    blogData.map((blog, index) => (
                      <tr key={index}>
                        <th scope="row">{(page - 1) * perPage + index + 1}</th>
                        <td className="blog-td blog-th-title">{blog.title}</td>
                        <td className="blog-td blog-th-short-desc">
                          {blog.short_description}
                        </td>
                        <td className="blog-td blog-th-meta-title">
                          {blog.meta_title}
                        </td>
                        <td className="blog-td blog-th-meta-desc">
                          {blog.meta_description}
                        </td>
                        <td className="blog-th-status">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={blog.status}
                                onChange={() =>
                                  handleStatusChange(blog.id, !blog.status)
                                }
                              />
                            }
                          />
                        </td>
                        <td className="blog-th-created-at">
                          {blog.created_at
                            ? moment(blog.created_at).format("DD MMMM, YYYY")
                            : "-"}
                        </td>
                        {permissions.includes(
                          "update-blog" || "delete-blog"
                        ) && (
                          <td className="text-center">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right
                              >
                                {permissions.includes("update-blog") && (
                                  <DropdownItem
                                    onClick={() => handleEdit(blog.id)}
                                  >
                                    <i
                                      className="fas fa-edit"
                                      style={{
                                        color: "#1976d2",
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Edit
                                  </DropdownItem>
                                )}
                                {permissions.includes("delete-blog") && (
                                  <DropdownItem
                                    onClick={() => handleDelete(blog.id)}
                                  >
                                    <i
                                      className="fas fa-trash"
                                      style={{
                                        color: "red",
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Delete
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>No record found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  page={page}
                  perPage={perPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  records={records}
                  prevButton={prevButton}
                  nextButton={nextButton}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Blogs;
